import React from 'react';
export function IntroSection() {
  return <div className="text-center mb-16" data-id="element-1111">
      <img src="https://drwzpk38qkpfb.cloudfront.net/www.peakedm.com/uploaded/images/Breton/Breton%20Genesi%20Polymer%20Additive%20Manufacturing%20Machine.jpg" alt="Breton Genesi Polymer Additive Manufacturing Machine" className="block max-w-full h-auto mx-auto rounded-xl shadow-lg mb-12" data-id="element-1112" />
      <div className="max-w-4xl mx-auto" data-id="element-1113">
        <h3 className="text-2xl md:text-3xl font-bold text-navy mb-6" data-id="element-1114">
          Genesi is Breton's 3D Printer for Large-Scale Production of
          Thermoplastic Materials
        </h3>
        <p className="text-lg text-gray-700 leading-relaxed mb-8" data-id="element-1115">
          Starting from the analysis of extrusion processes, Breton has
          developed a wide range of machining centers to exploit the potential
          of '<strong data-id="element-1116">Large Scale Additive Manufacturing</strong>' on
          thermoplastic materials.
        </p>
        <div className="flex flex-col sm:flex-row justify-center items-center gap-6" data-id="element-1117">
          <a href="https://www.peakedm.com/ContactPeakMachineSales.html?i515589:default[Product%20Title]=Breton%20Genesi%20LSAM" target="_blank" rel="noopener noreferrer" className="text-[#9B0137] hover:text-orange transition-colors font-bold uppercase text-lg tracking-wide flex items-center" data-id="element-1118">
            <span className="mr-2" data-id="element-1119">+</span> REQUEST Brochure / QUOTE
          </a>
          <a href="https://www.breton.it/en/machine-tools/genesi-the-3d-printer-for-the-large-scale-addivitive-manufacturing" target="_blank" rel="noopener noreferrer" className="text-[#9B0137] hover:text-orange transition-colors font-bold uppercase text-lg tracking-wide flex items-center" data-id="element-1120">
            <span className="mr-2" data-id="element-1121">+</span> ADDITIONAL INFORMATION
          </a>
        </div>
      </div>
    </div>;
}